module.exports = __webpack_public_path__ + "4dcfcc2f3e7b3708534973371f35a3fb.svg";